import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import ContextTable from "../../../components/ContextTable";
import QuantityCard from "../../../components/QuantityCard";
import ServiceOrderForm from "../../../components/ServiceOrdersForm/ServiceOrderForm";
import ServiceOrderReportsAttendance from "../../../components/ServiceOrderReportsAttendance";
import { useAuth } from "../../../contexts/AuthContext";
import { useServiceOrder } from "../../../contexts/ServiceOrderContext";
import {
  tableData,
  technicianBodyTemplate
} from "../../../contexts/ServiceOrderContext/ConstData";
import { withServiceOrderContext } from "../../../contexts/ServiceOrderContext/withServiceOrder";
import api from "../../../services/api";

function objectToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      keyValuePairs.push(
        encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
      );
    }
  }
  return keyValuePairs.join("&");
}

const ServiceOrderTable = () => {
  const context = useServiceOrder();
  const { token } = useAuth();
  const toast = useRef(null);
  const [opened, setOpened] = useState(0);
  const [running, setRunning] = useState(0);
  const [awaitingTechnician, setAwaitingTechnician] = useState(0);
  const [awaitingPart, setAwaitingPart] = useState(0);
  const [equipmentLiberado, setEquipmentLiberado] = useState(0);
  const [closed, setClosed] = useState(0);
  const [filterObject, setFilterObject] = useState({});
  const [reportsAttendanceModal, setReportsAttendanceModal] = useState(false);
  const [currentServiceOrder, setCurrentServiceOrder] = useState(null);

  useEffect(() => {
    api
      .get(`service_order/getStatusCount?${objectToQueryString(filterObject)}`)
      .then((response) => {
        setOpened(response.data.opened);
        setRunning(response.data.running);
        setAwaitingTechnician(response.data.awaiting_technician);
        setAwaitingPart(response.data.awaiting_part);
        setEquipmentLiberado(response.data.equipment_liberado);
        setClosed(response.data.closed);
      });
  }, [filterObject]);

  const openFormModal = async (rowData = null) => {
    document.body.style.position = "fixed";
    context.setFormModalOpened(true);
    if (rowData) {
      await context.setSelectedItem(rowData);
    }
  };
  const hideFormModal = () => {
    document.body.style.position = "relative";
    context.setFormModalOpened(false);
  };

  const actionTemplate = (rowData, access_type) => {
    return (
      <React.Fragment>
        <Button
          tooltip="Editar"
          tooltipOptions={{ position: "top" }}
          icon="pi pi-pencil"
          className="p-button-rounded p-button-warning text-white p-mr-2 me-2"
          onClick={() => openFormModal(rowData)}
        />

        <Button
          icon="pi pi-th-large"
          tooltip="Qr Code"
          tooltipOptions={{ position: "top" }}
          style={{ backgroundColor: "#1c3424", outline: 0, border: "none" }}
          className="p-button-rounded p-button text-white"
          onClick={() => {
            window
              .open(
                process.env.REACT_APP_LARAVEL_APP +
                  `api/service_order/qr_code?id=${rowData.id}&access_token=${token}`,
                "_blank"
              )
              .focus();
          }}
        />

        <Button
          tooltip="Download relátorio"
          tooltipOptions={{ position: "top" }}
          icon="pi pi-file-pdf"
          style={{
            backgroundColor: "#7f0b0b",
            outline: 0,
            border: "none",
            marginLeft: 6
          }}
          className="p-button-rounded p-button text-white"
          onClick={() =>
            window.open(`/pdf/service_order;${rowData.id}`, "_blank").focus()
          }
        />

        {access_type === "Admin" && (
          <Button
            tooltip="Editar horários de atendimento dos relatórios"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-clock"
            style={{
              backgroundColor: "#0066cc",
              outline: 0,
              border: "none",
              marginLeft: 6
            }}
            className="p-button-rounded p-button text-white"
            onClick={() => {
              setCurrentServiceOrder(rowData);
              setReportsAttendanceModal(true);
            }}
          />
        )}
      </React.Fragment>
    );
  };

  tableData.find((data) => data.header === "Ações").body = actionTemplate;

  const handleChangeStatus = (status) => {
    if (status === selectedStatus) {
      setSelectedStatus("");
      return;
    }
    setSelectedStatus(status);
  };

  const [selectedStatus, setSelectedStatus] = useState("");

  // Coluna "Técnico" só faz sentido filtrando por "Em andamento" (mostra
  // quem está com a OS agora, aproximado pelo relatório mais recente).
  // tableData é o array compartilhado vindo do context (mesmo padrão do
  // actionTemplate acima) — inserida/removida aqui pra não poluir as
  // outras telas que reaproveitam esse mesmo array.
  const technicianColumnIndex = tableData.findIndex(
    (data) => data.name === "current_technician"
  );
  if (selectedStatus === "Em andamento") {
    if (technicianColumnIndex === -1) {
      const statusColumnIndex = tableData.findIndex(
        (data) => data.name === "status"
      );
      tableData.splice(statusColumnIndex + 1, 0, {
        name: "current_technician",
        header: "Técnico",
        body: technicianBodyTemplate,
        sortable: false
      });
    }
  } else if (technicianColumnIndex !== -1) {
    tableData.splice(technicianColumnIndex, 1);
  }

  return (
    <div>
      <Toast style={{ zIndex: 1101 }} ref={toast} />
      <ServiceOrderForm
        visible={context.formModalOpened}
        onHide={hideFormModal}
        toast={toast}
        selectedStatus={selectedStatus}
      />
      <ServiceOrderReportsAttendance
        visible={reportsAttendanceModal}
        onHide={() => {
          setReportsAttendanceModal(false);
          setCurrentServiceOrder(null);
        }}
        serviceOrderId={currentServiceOrder?.id}
        onSubmit={() => {
          context.getFromApi({ status: selectedStatus });
        }}
      />
      <>
        <div
          className={
            "d-flex flex-row justify-content-around align-content-center pb-2 gap-2"
          }
        >
          <QuantityCard
            onClick={() => handleChangeStatus("Aberto")}
            label={"Abertos"}
            isSelected={"Aberto" === selectedStatus}
            color={"#9E3131"}
            value={opened}
          />
          <QuantityCard
            onClick={() => handleChangeStatus("Fechado")}
            label={"Fechados"}
            isSelected={"Fechado" === selectedStatus}
            color={"#003B17"}
            value={closed}
          />
          <QuantityCard
            onClick={() => handleChangeStatus("Em andamento")}
            label={"Em andamento"}
            isSelected={"Em andamento" === selectedStatus}
            color={"#FAC02D"}
            value={running}
          />
          <QuantityCard
            onClick={() => handleChangeStatus("Aguardando técnico")}
            label={"Aguardando técnico"}
            isSelected={"Aguardando técnico" === selectedStatus}
            color={"#1976D2"}
            value={awaitingTechnician}
          />
          <QuantityCard
            onClick={() => handleChangeStatus("Pendente peça")}
            label={"Aguardando peça"}
            isSelected={"Pendente peça" === selectedStatus}
            color={"#FF8B00"}
            value={awaitingPart}
          />
          <QuantityCard
            onClick={() => handleChangeStatus("Equipamento liberado")}
            label={"Equipamento liberado"}
            isSelected={"Equipamento liberado" === selectedStatus}
            color={"#2E7D32"}
            value={equipmentLiberado}
          />
        </div>
      </>
      <ContextTable
        type={"ServiceOrder"}
        setFilterObject={setFilterObject}
        selectedStatus={selectedStatus}
        context={context}
        openForm={openFormModal}
        defaultOrderBy="created_at"
      />
    </div>
  );
};

export default withServiceOrderContext(ServiceOrderTable);
